"use client";
import { jsxs as a, Fragment as M, jsx as o } from "react/jsx-runtime";
import r from "@emotion/styled";
import { FONT_WEIGHTS as C } from "../../tokens/font-weights/FontWeights.js";
import { SPACINGS as $ } from "../../tokens/spacings/Spacings.js";
import { forwardRef as f } from "react";
import e from "./PaginationControl.js";
const c = f(
  ({
    "aria-label": m = "Pagination",
    feControls: p,
    feDelimiter: x = "of",
    feHideTotal: g = !1,
    feItemsPerPage: n = 50,
    feOnPageChange: s,
    fePage: i,
    feTotal: t,
    ...h
  }, y) => {
    const { next: b, prev: S } = p ?? {}, N = Math.ceil(t / n);
    i = Math.max(1, Math.min(N, i));
    const l = (i - 1) * n + 1, d = Math.min(l + n - 1, t), u = d >= t, v = i <= 1;
    return /* @__PURE__ */ a(j, { ...h, "aria-label": m, "data-comp": "pagination", ref: y, children: [
      /* @__PURE__ */ a(k, { children: [
        l,
        " - ",
        d
      ] }),
      !g && /* @__PURE__ */ a(M, { children: [
        /* @__PURE__ */ o(w, { children: x }),
        t
      ] }),
      /* @__PURE__ */ o(
        e,
        {
          ...S,
          disabled: v,
          onClick: () => s(i - 1),
          type: "Previous page"
        }
      ),
      /* @__PURE__ */ o(
        e,
        {
          ...b,
          disabled: u,
          onClick: () => s(i + 1),
          type: "Next page"
        }
      )
    ] });
  }
);
c.displayName = "Pagination";
const H = c, j = r.nav`
	align-items: center;
	display: inline-flex;
`, k = r.span`
	font-weight: ${C.bold};
`, w = r.span`
	margin: 0 ${$.xxs};
`;
export {
  H as default
};
